import * as React from 'react'

import { cn } from '@/shared/utils/cn'

/**
 * @fileoverview Shadcn Textarea primitive mirroring Input semantics.
 * @module components/ui/textarea
 */

/**
 * Multiline text control with consistent focus, invalid, and autofill styles.
 *
 * @component
 * @param props Native textarea props.
 * @returns Styled textarea element.
 */
function Textarea({ className, ...props }: React.ComponentProps<'textarea'>): React.ReactElement {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'bg-input text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground',
        'flex min-h-[80px] w-full rounded-md border border-input px-3 py-2 text-base md:text-sm',
        'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 outline-none transition-[color,box-shadow]',
        'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-70',
        'aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40',
        'dark:bg-input',
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
